import type { DaytonaRouter } from "replo-publisher/src/trpc/routers/daytona";

import { getNamespacedQueryClient } from "@v2/trpc/trpc";

import { createTrpcRouterConfig } from "../config";

const {
  router: daytonaRouter,
  client: daytonaClient,
  utils: daytonaUtils,
  options: daytonaOptions,
} = createTrpcRouterConfig<DaytonaRouter>({
  path: "daytona",
  queryClient: getNamespacedQueryClient("daytona"),
});

export { daytonaClient, daytonaRouter, daytonaUtils, daytonaOptions };
